declare namespace $ {

	type $mol_button_minor__click_shm_hitalama_skills_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['add_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_skills_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_skills_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__event_shm_hitalama_skills_4 = $mol_type_enforce<
		({ 
			mouseenter( next?: ReturnType< $shm_hitalama_skills['add_enter'] > ): ReturnType< $shm_hitalama_skills['add_enter'] >,
			keydown( next?: ReturnType< $shm_hitalama_skills['add_keydown'] > ): ReturnType< $shm_hitalama_skills['add_keydown'] >,
		})  & ReturnType< $mol_pop_over['event'] >
		,
		ReturnType< $mol_pop_over['event'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_skills_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['Add_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_skills_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['add_content'] >
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_check_icon__hint_shm_hitalama_skills_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__checked_shm_hitalama_skills_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['repository_opened'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_skills_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['Repository_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_text__text_shm_hitalama_skills_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_hitalama_skills_item__entry_shm_hitalama_skills_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['entry'] >
		,
		ReturnType< $shm_hitalama_skills_item['entry'] >
	>
	type $shm_hitalama_skills_item__catalog_shm_hitalama_skills_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['catalog'] >
		,
		ReturnType< $shm_hitalama_skills_item['catalog'] >
	>
	type $shm_hitalama_skills_item__add_skill_shm_hitalama_skills_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['add_skill_in'] >
		,
		ReturnType< $shm_hitalama_skills_item['add_skill'] >
	>
	type $shm_hitalama_skills_item__add_group_shm_hitalama_skills_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['add_group_in'] >
		,
		ReturnType< $shm_hitalama_skills_item['add_group'] >
	>
	type $shm_hitalama_skills_drag__catalog_shm_hitalama_skills_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['catalog'] >
		,
		ReturnType< $shm_hitalama_skills_drag['catalog'] >
	>
	type $shm_hitalama_skills_drag__locked_shm_hitalama_skills_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['drag_locked'] >
		,
		ReturnType< $shm_hitalama_skills_drag['locked'] >
	>
	type $shm_hitalama_skills_drag__reversed_shm_hitalama_skills_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['drag_reversed'] >
		,
		ReturnType< $shm_hitalama_skills_drag['reversed'] >
	>
	type $shm_hitalama_skills_drag__roots_shm_hitalama_skills_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['roots'] >
		,
		ReturnType< $shm_hitalama_skills_drag['roots'] >
	>
	type $shm_hitalama_skills_drag__children_shm_hitalama_skills_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['children'] >
		,
		ReturnType< $shm_hitalama_skills_drag['children'] >
	>
	type $shm_hitalama_skills_drag__expanded_shm_hitalama_skills_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['expanded'] >
		,
		ReturnType< $shm_hitalama_skills_drag['expanded'] >
	>
	type $shm_hitalama_skills_drag__Item_shm_hitalama_skills_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['Item'] >
		,
		ReturnType< $shm_hitalama_skills_drag['Item'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['add_group'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_skills_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['add_skill'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_skills_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__hint_shm_hitalama_skills_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['new_name_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_skills_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['new_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_skills_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['folder_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_skills_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['new_parent'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_button_major__title_shm_hitalama_skills_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['create_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_skills_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_skills_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['cancel_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_skills_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_skills_35 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__question_shm_hitalama_skills_36 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['question'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_skills_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['delete_skill'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_button_minor__hint_shm_hitalama_skills_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['close_editor'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_skills_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_list_page__title_shm_hitalama_skills_41 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_page['title'] >
	>
	type $shm_list_page__minimal_width_shm_hitalama_skills_42 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_list_page['minimal_width'] >
	>
	type $shm_list_page__filter_shm_hitalama_skills_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['query'] >
		,
		ReturnType< $shm_list_page['filter'] >
	>
	type $shm_list_page__sort_order_shm_hitalama_skills_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['sort_order'] >
		,
		ReturnType< $shm_list_page['sort_order'] >
	>
	type $shm_list_page__add_content_shm_hitalama_skills_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['add_content'] >
	>
	type $shm_list_page__body_shm_hitalama_skills_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['body'] >
	>
	type $mol_list__sub_shm_hitalama_skills_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_list__sub_shm_hitalama_skills_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_guide_toggle__section_shm_hitalama_skills_49 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_toggle['section'] >
	>
	type $shm_hitalama_skills_repository__catalog_shm_hitalama_skills_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['catalog'] >
		,
		ReturnType< $shm_hitalama_skills_repository['catalog'] >
	>
	type $shm_hitalama_skills_repository__opened_shm_hitalama_skills_51 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['repository_opened'] >
		,
		ReturnType< $shm_hitalama_skills_repository['opened'] >
	>
	type $shm_hitalama_skills_editor__entry_shm_hitalama_skills_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['selected_entry'] >
		,
		ReturnType< $shm_hitalama_skills_editor['entry'] >
	>
	type $shm_hitalama_skills_editor__editing_shm_hitalama_skills_53 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_skills_editor['editing'] >
	>
	type $shm_hitalama_skills_editor__editor_open_shm_hitalama_skills_54 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['editing'] >
		,
		ReturnType< $shm_hitalama_skills_editor['editor_open'] >
	>
	type $shm_hitalama_skills_editor__entry_shm_hitalama_skills_55 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills['selected_entry'] >
		,
		ReturnType< $shm_hitalama_skills_editor['entry'] >
	>
	type $shm_hitalama_skills_editor__editing_shm_hitalama_skills_56 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_skills_editor['editing'] >
	>
	type $shm_hitalama_skills_editor__tools_shm_hitalama_skills_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_skills_editor['tools'] >
	>
	export class $shm_hitalama_skills extends $mol_book2 {
		skill_pages( ): readonly($mol_view)[]
		query( next?: string ): string
		sort_order( next?: string ): string
		add_enter( next?: any ): any
		add_keydown( next?: any ): any
		add_open( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add_anchor( ): $mol_button_minor
		add_content( ): readonly($mol_view)[]
		Add( ): $mol_pop_over
		repository_opened( next?: boolean ): boolean
		Repository_icon( ): $mol_icon_cog
		Repository_toggle( ): $mol_check_icon
		Public_notice( ): $mol_text
		catalog( ): $shm_hitalama_skills_catalog
		drag_locked( ): boolean
		drag_reversed( ): boolean
		roots( ): readonly(any)[]
		children( id: any): readonly(any)[]
		expanded( id: any, next?: boolean ): boolean
		entry( id: any): $shm_hitalama_skills_entry
		add_skill_in( id: any, next?: any ): any
		add_group_in( id: any, next?: any ): any
		Item( id: any): $shm_hitalama_skills_item
		Names( ): $shm_hitalama_skills_drag
		add_group( next?: any ): any
		Group_icon( ): $mol_icon_folder
		Add_group( ): $mol_button_minor
		add_skill( next?: any ): any
		Skill_icon( ): $mol_icon_plus
		Add_skill( ): $mol_button_minor
		new_name_hint( ): string
		new_name( next?: string ): string
		Name( ): $mol_string
		folder_options( ): Record<string, any>
		new_parent( next?: string ): string
		Parent( ): $mol_select
		create_title( ): string
		create( next?: any ): any
		Create( ): $mol_button_major
		cancel_create( next?: any ): any
		Cancel( ): $mol_button_minor
		Create_actions( ): $mol_view
		selected_entry( ): $shm_hitalama_skills_entry
		editing( next?: boolean ): boolean
		delete_skill( next?: any ): any
		Delete_skill( ): $shm_confirm_delete
		close_editor( next?: any ): any
		Editor_close_icon( ): $mol_icon_close
		Close_editor( ): $mol_button_minor
		menu_title( ): string
		pages( ): ReturnType< $shm_hitalama_skills['skill_pages'] >
		List( ): $shm_list_page
		Add_menu( ): $mol_list
		Create_form( ): $mol_list
		Help( ): $shm_hitalama_guide_toggle
		create_kind( next?: string ): string
		Repository( ): $shm_hitalama_skills_repository
		Viewer( ): $shm_hitalama_skills_editor
		Editor( ): $shm_hitalama_skills_editor
	}
	
}

//# sourceMappingURL=skills.view.tree.d.ts.map